var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"player"}},[_c('vytia-player',{ref:"yt",attrs:{"width":"100%","yturl":_vm.resource.url,"playerVars":_vm.playerVars},on:{"ready":_vm.onPlayerReady,"playing":_vm.onPlayerPlay}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }